export default {
      id: "i-info-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "img/sprite.svg#i-info",
      toString: function () {
        return this.url;
      }
    }